import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Oferta from "./pages/Oferta";
import Kontakt from "./pages/Kontakt";
import PolitykaPrywatnosci from "./pages/PolitykaPrywatnosci";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileCallBar from "./components/MobileCallBar";
import CookieBanner from "./components/CookieBanner";
import Cms from "./pages/Cms";
import CmsPage from "./pages/CmsPage";

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/oferta"} component={Oferta} />
      <Route path={"/kontakt"} component={Kontakt} />
      <Route path={"/polityka-prywatnosci"} component={PolitykaPrywatnosci} />
      <Route path={"/cms"} component={Cms} />
      <Route path={"/strona/:slug"} component={CmsPage} />
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  const isCms = window.location.pathname === "/cms";
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
      >
        <TooltipProvider>
          <Toaster />
          {!isCms && <Header />}
          <main>
            <Router />
          </main>
          {!isCms && <Footer />}
          {!isCms && <MobileCallBar />}
          {!isCms && <CookieBanner />}
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
